import React from "react";

export function Container({ className = "", as: Comp = "div", ...props }) {
  return (
    // `Container` standardizes page horizontal padding + max width.
    // - max-w-[1280px] matches the design from code.html
    // - px-6 lg:px-40 matches the responsive gutters used across sections
    // - `as` lets callers choose the HTML element (<div>, <section>, <footer>, etc.)
    <Comp
      className={`mx-auto w-full max-w-[1480px] px-6 lg:px-40 ${className}`.trim()}
      {...props}
    />
  );
}


